import { IGameDevelopersState } from './gameDevelopersContext';
import { GameDevelopersActionTypes, TGameDevelopersAction } from './gameDevelopersActions';

export const gameDevelopersReducer = (
	state: IGameDevelopersState,
	action: TGameDevelopersAction,
): IGameDevelopersState => {
	switch (action.type) {
		case GameDevelopersActionTypes.SET_GAME_DEVELOPERS:
			return {
				...state,
				gameDevelopers: action.payload.gameDevelopers,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameDevelopersActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case GameDevelopersActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				currentPage: 1,
			};
		case GameDevelopersActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case GameDevelopersActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case GameDevelopersActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case GameDevelopersActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameDevelopersActionTypes.SET_ID_FOR_EDIT:
			return {
				...state,
				IDForEdit: action.payload.IDForEdit,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameDevelopersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameDevelopersActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		case GameDevelopersActionTypes.REFETCH_DEVELOPERS:
			return {
				...state,
				needRefetchDevelopers: action.payload.needRefetchDevelopers,
			};
		default:
			return state;
	}
};
